import { connect, useDispatch } from "react-redux";
import { ContentType } from "../../apiFunctions/sop/content_type";
import SectionCard from "../../pages/sop/sectionCard";
import { GlobalState } from "../../store/reducers";
import EmptySection from "./EmptySection";
import { setToggleResults } from "../../store/sop/actions";
import ToggleResults from "./GenerationUI/ToggleResults";
import { useEffect } from "react";
interface RightSectionProps {}

interface RightSectionProps {
  setOpenModal: any;
  copies: any;
  contentType?: ContentType;
}

const RightSection: React.FC<RightSectionProps> = ({
  copies,
  setOpenModal,
  contentType,
}) => {
  const dispatch = useDispatch();
  const handleEdit = () => {};
  useEffect(() => {
    if (copies) {
      dispatch(setToggleResults(true));

      return;
    }

    dispatch(setToggleResults(false));

    return;
  }, [copies]);
  return (
    <>
      {copies ? (
        <div className="font-Inter w-full bg-white pb-14 md:pb-0">
          {copies?.map((copy: any, index: number) => {
            return (
              <div key={index}>
                <SectionCard
                  setOpenModal={setOpenModal}
                  text={copy?.output?.data?.text}
                  rating={copy?.rating}
                  id={copy?.id}
                  handleEdit={handleEdit}
                  contentType={contentType}
                />
              </div>
            );
          })}
          <ToggleResults className="pb-6" />
        </div>
      ) : (
        <EmptySection />
      )}
    </>
  );
};

const mapStateToPros = (state: GlobalState) => {
  return {
    copies: state.sop?.copies,
  };
};

export default connect(mapStateToPros)(RightSection);
